import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 rounded-lg font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#4a7c2c] hover:bg-[#3d6624] text-white shadow-lg shadow-[#4a7c2c]/20 focus:ring-[#4a7c2c]',
    secondary: 'bg-[#6b9d3e] hover:bg-[#5a8534] text-white shadow-md focus:ring-[#6b9d3e]',
    outline: 'border-2 border-[#4a7c2c] text-[#4a7c2c] hover:bg-[#4a7c2c]/5 focus:ring-[#4a7c2c]'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-155">
      {children}
    </motion.button>;
}